<ca-modal-container [modalTitle]="'WORKFLOWS.PUBLICATION.HEADLINE' | translate" (dismiss)="dismiss('Canceled')">
    <form [formGroup]="formGroup" (ngSubmit)="submit()">
        <div class="mb-3">
            <div class="d-flex flex-column-reverse">
                <input
                    type="text"
                    class="form-control"
                    id="title"
                    [placeholder]="'WORKFLOWS.METADATA_EDITOR_AND_PUBLICATION_MODAL.TITLE.PLACEHOLDER' | translate"
                    formControlName="title"
                    [ngClass]="formGroup.get('title')?.errors ? 'has-error' : ''"
                />
                <label for="title">{{ 'GENERAL.TITLE' | translate }} <span class="red">*</span></label>
            </div>
            <small *ngIf="formGroup.get('title')?.hasError('pattern')" class="invalid-feedback">{{ 'GENERAL.INVALID_TITLE' | translate }}</small>
            <small *ngIf="formGroup.get('title')?.hasError('maxlength')" class="invalid-feedback">
                {{ 'GENERAL.CANNOT_EXCEED_CHARS' | translate: { fieldName: 'Title', limit: titleLengthLimit } }}
            </small>
            <small *ngIf="formGroup.get('title')?.touched && formGroup.get('title')?.hasError('required')" class="invalid-feedback">{{
                'GENERAL.REQUIRED_FIELD' | translate
            }}</small>
        </div>
        <div class="mb-3">
            <div class="d-flex flex-column-reverse">
                <textarea
                    class="form-control"
                    id="summary"
                    placeholder="{{ 'WORKFLOWS.METADATA_EDITOR_AND_PUBLICATION_MODAL.SHORT_SUMMARY.PLACEHOLDER' | translate }}"
                    formControlName="summary"
                    data-uit="workflow-publish-summary-input"
                    [ngClass]="formGroup.get('summary')?.errors && formGroup.get('summary')?.touched ? 'has-error' : ''"
                ></textarea>
                <label for="summary">{{ 'WORKFLOWS.METADATA_EDITOR_AND_PUBLICATION_MODAL.SHORT_SUMMARY.LABEL' | translate }} <span class="red">*</span></label>
            </div>
            <small *ngIf="formGroup.get('summary')?.touched && formGroup.get('summary')?.hasError('maxWordsNumberReached')" class="invalid-feedback">
                {{ 'GENERAL.CANNOT_EXCEED_CHARS' | translate: { fieldName: 'Summary', limit: summaryLengthLimit } }}
            </small>
            <small *ngIf="formGroup.get('summary')?.touched && formGroup.get('summary')?.hasError('required')" class="invalid-feedback">{{
                'GENERAL.REQUIRED_FIELD' | translate
            }}</small>
        </div>
        <div class="mb-3">
            <div class="d-flex flex-column-reverse">
                <ca-quill-editor-wrapper
                    id="description"
                    formControlName="description"
                    [placeholder]="'WORKFLOWS.METADATA_EDITOR_AND_PUBLICATION_MODAL.DETAILED_DESCRIPTION.PLACEHOLDER' | translate"
                    [required]="true"
                    (touched)="onTouched()"
                    data-uit="workflow-publish-description-input"
                    [ngClass]="description.touched && description.errors ? 'has-error' : ''"
                ></ca-quill-editor-wrapper>
                <label for="description">
                    {{ 'WORKFLOWS.METADATA_EDITOR_AND_PUBLICATION_MODAL.DETAILED_DESCRIPTION.LABEL' | translate }}
                    <span class="red">*</span>
                </label>
            </div>
            <small *ngIf="description.touched && description.errors?.maxLength" class="invalid-feedback">
                {{ 'MODULES.EDITOR.DESCRIPTION_TOO_LONG' | translate: { descriptionLengthLimit: descriptionLengthLimit } }}
            </small>
            <small *ngIf="description.touched && description.errors?.required" class="invalid-feedback">
                {{ 'GENERAL.REQUIRED_FIELD' | translate }}
            </small>
        </div>
        <div class="description mb-3">
            <div class="d-flex flex-column-reverse">
                <textarea
                    id="commentToReviewer"
                    class="form-control"
                    [placeholder]="'WORKFLOWS.PUBLICATION.COMMENT_TO_REVIEWER.PLACEHOLDER' | translate"
                    formControlName="commentToReviewer"
                    data-uit="workflow-publish-comment-input"
                    [ngClass]="formGroup.get('commentToReviewer')?.errors && formGroup.get('commentToReviewer')?.dirty ? 'has-error' : ''"
                ></textarea>
                <label for="commentToReviewer">{{ 'WORKFLOWS.PUBLICATION.COMMENT_TO_REVIEWER.LABEL' | translate }} <span class="red">*</span></label>
            </div>
            <small *ngIf="formGroup.get('commentToReviewer')?.dirty && formGroup.get('commentToReviewer')?.hasError('maxlength')" class="invalid-feedback">
                {{ 'GENERAL.CANNOT_EXCEED_CHARS' | translate: { fieldName: 'Comment to Reviewer', limit: descriptionLengthLimit } }}
            </small>
            <small *ngIf="formGroup.get('commentToReviewer')?.dirty && formGroup.get('commentToReviewer')?.hasError('required')" class="invalid-feedback">
                {{ 'GENERAL.REQUIRED_FIELD' | translate }}
            </small>
        </div>
        <div class="mb-3">
            <div class="d-flex flex-column-reverse">
                <ng-select
                    *ngIf="categories"
                    labelForId="category"
                    formControlName="categoryId"
                    [placeholder]="'WORKFLOWS.METADATA_EDITOR_AND_PUBLICATION_MODAL.CATEGORY.PLACEHOLDER' | translate"
                    appendTo="body"
                    [searchable]="false"
                    [clearable]="false"
                    data-uit="workflow-publish-category-select"
                >
                    <ng-option *ngFor="let category of categories" [value]="category.id">{{ category?.name }}</ng-option>
                </ng-select>
                <label for="category">{{ 'GENERAL.CATEGORY' | translate }} <span class="red">*</span></label>
            </div>
            <small *ngIf="formGroup.get('categoryId')?.touched && formGroup.get('categoryId')?.hasError('required')" class="invalid-feedback">
                {{ 'GENERAL.REQUIRED_FIELD' | translate }}
            </small>
        </div>
        <div class="modal-buttons">
            <button type="submit" [disabled]="isSubmitting || formGroup.invalid" class="btn btn-primary" caAutoFocus data-uit="workflow-publish-save-btn">
                {{ 'WORKFLOWS.PUBLICATION.SUBMIT' | translate }}
            </button>
        </div>
    </form>
</ca-modal-container>
